import styled from "styled-components";
import { Link } from "react-router-dom";

export const HiveColLink = styled(Link)`
    color: var(--functionbutton-secondary-label-color-default, rgba(16, 24, 40, 1));
    font-size: 14px;
    font-weight: 500;
    display: flex;
    align-items: center;
`;

export const DevicesColPin = styled.div<{ $color: string; $bg: string }>`
    //background: ${({ $bg }) => $bg};
    color: ${({ $color }) => $color};
    padding: 2px 8px;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 500;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    line-height: 16px;
    white-space: nowrap;

    svg {
        width: 16px;
        height: 16px;
    }

    svg path {
        fill: ${({ $color }) => $color};
    }
`;

export const DisableButtonWrapper = styled.div`
    display: flex;
    gap: 4px;
    align-items: center;
    padding-right: 8px;
    cursor: pointer;

    color: var(--error-default, rgba(255, 38, 38, 1));
    font-size: 14px;
    font-weight: 500;
`
